<template>
  <v-app>
    <external-app-bar />

    <external-view />

    <!-- <pages-footer /> -->
  </v-app>
</template>

<script>
import externalAppBar from "../../external/AppBar";
import externalView from "../../external/View";

// import PagesCoreFooter from "./components/core/Footer";

export default {
  name: "Auth",

  components: {
    "external-app-bar": externalAppBar,
    "external-view": externalView,
    // "pages-core-footer": PagesCoreFooter,
  },

  created() {},

  beforeDestroy() {},
};
</script>
